import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoConfiguracionEstadoEditarComponent {
  constructor($q, FanProyectoCatalogosEstadosService, FanProyectoConfiguracionEstadoService) {
    this.$q = $q
    this.FanProyectoCatalogosEstadosService = FanProyectoCatalogosEstadosService
    this.FanProyectoConfiguracionEstadoService = FanProyectoConfiguracionEstadoService
    this.idProyecto = undefined
    this.idEstado = undefined
    this.onChange = undefined
    this.onClose = undefined
    this.estado = null
  }

  $onInit() {
    this.promise =
      this.FanProyectoCatalogosEstadosService.get()
        .then((response) => {
          this.estados = response.data
          this.estado = response.data.find((item) => item.id === this.idEstado)
        })
  }

  cancelar() {
    this.onClose()
  }

  actualizar() {
    this.actualizando = true

    let data = {
      id_estado: this.estado.id,
      impuesto_estatal_porcentaje: this.estado.impuesto_estatal_porcentaje,
    }

    return this.FanProyectoConfiguracionEstadoService.put(this.idProyecto, data)
      .then((response) => {
        this.data = response.data

        this.onChange({$event: {data: this.data}})
        this.onClose()

      })
      .finally(() => (this.actualizando = false))
  }
}

module.component('fanProyectoConfigEstadoEditar', {
  controller: FanProyectoConfiguracionEstadoEditarComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    idEstado: '<',
    onChange: '&',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/configuracion/estado/editar/component.js